import { CartQuery } from "@generated"
import { queryClient } from "@lib/query-client"

export function setCartQueryData(
  reference: string,
  data: CartQuery["choicesCart"]
) {
  if (data.items && typeof reference === "string") {
    queryClient.setQueryData(["cart", reference], {
      choicesCart: data,
    })
  }
}
